import _styled from "styled-components";
const _excluded = ["isChecked", "isDisabled", "isSwitch", "defaultChecked", "onChange", "title", "name", "value", "children", "textProps", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom-collections.iterator.js";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { Children, isValidElement, cloneElement, forwardRef, memo, useCallback, useState, useId } from "react";
import { TextSpan } from "../Text";
import { SpacingSpan } from "../Spacing";
import CheckboxIcon from "./Elements/CheckboxIcon";
import HiddenCheckbox from "./Elements/HiddenCheckbox";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Checkbox = /*#__PURE__*/forwardRef(function Checkbox(props, ref) {
  const {
      isChecked: isCheckedProp,
      isDisabled = false,
      isSwitch = false,
      defaultChecked = false,
      onChange: onChangeProps,
      title,
      name,
      value,
      children,
      textProps,
      className
    } = props,
    _rest = _objectWithoutProperties(props, _excluded);
  const [isCheckedState, setIsCheckedState] = useState(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
  const onChange = useCallback(e => {
    setIsCheckedState(e.target.checked);
    if (onChangeProps) {
      onChangeProps(e);
    }
  }, [onChangeProps]);

  // Use isChecked from the state if it is controlled
  const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
  const id = useId();

  // Add props to children
  const childrenWithProps = Children.map(children, child => {
    // Checking isValidElement is the safe way and avoids a typescript
    // error too.
    if (/*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/cloneElement(child, {
        isDisabled,
        isChecked,
        style: {
          fontSize: "inherit"
        }
      });
    }
    return child;
  });
  return /*#__PURE__*/_jsxs(_StyledTextSpan, _objectSpread(_objectSpread({
    as: "label",
    title: title,
    htmlFor: "checkbox-".concat(id),
    className: className
  }, textProps), {}, {
    $_css: isSwitch && "gap: 5px;",
    $_css2: !isDisabled && "\n            cursor: pointer;\n            &:hover svg {\n              opacity: 0.6;\n            }\n          ",
    $_css3: isDisabled && "\n            cursor: not-allowed;\n          ",
    children: [/*#__PURE__*/_jsx(HiddenCheckbox, {
      disabled: isDisabled,
      checked: isChecked,
      onChange: onChange,
      value: value,
      name: name,
      id: "checkbox-".concat(id),
      ref: ref
    }), /*#__PURE__*/_jsx(CheckboxIcon, {
      isSwitch: isSwitch,
      isChecked: isChecked,
      isDisabled: isDisabled
    }), /*#__PURE__*/_jsx(SpacingSpan, {
      right: 1
    }), childrenWithProps]
  }));
});
Checkbox.displayName = "Checkbox";
export default /*#__PURE__*/memo(Checkbox);
var _StyledTextSpan = _styled(TextSpan).withConfig({
  displayName: "Checkbox___StyledTextSpan",
  componentId: "sc-ux9pta-0"
})(["display:flex;flex-shrink:0;", " align-items:center;&:focus-within{outline:3px solid #c390f9;}", " ", ""], p => p.$_css, p => p.$_css2, p => p.$_css3);